import { SurfaceDefectChip } from "@/shared/components/SurfaceDefectChip";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { SurfaceDefect } from "@/shared/models/Inspection";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (surfaceDefect: SurfaceDefect) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "SurfaceDefectName",
			headerName: "Name",
			minWidth: 20,
			flex: 3,
			cellRenderer: (params: ICellRendererParams) => (
				<SurfaceDefectChip
					name={(params.data as SurfaceDefect).SurfaceDefectName}
					color={(params.data as SurfaceDefect).Color}
				/>
			),
		},
		{
			field: "UsageCount",
			headerName: "Readings",
			minWidth: 20,
			flex: 1,
		},
		{
			headerName: "",
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as SurfaceDefect,
				edit: true,
				showDelete: true,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "surfaceDefectContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			sortable: false,
			flex: 1,
			minWidth: 200,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	return { columnDefs };
};
